/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Scenario for the plan design
 */
export enum Scenario {
  BASIC = 'BASIC',
  ENHANCED = 'ENHANCED',
  ESSENTIAL = 'ESSENTIAL',
  STANDARD = 'STANDARD',
  EXCEPTIONAL = 'EXCEPTIONAL',
  LOW_COST_GOLD = 'LOW_COST_GOLD',
  LOW_COST_SILVER = 'LOW_COST_SILVER',
  LOW_COST_PLATINUM = 'LOW_COST_PLATINUM',
  ON_MARKET_LOW_COST_SILVER = 'ON_MARKET_LOW_COST_SILVER',
  SIMILAR_CARE = 'SIMILAR_CARE',
  SAME_ICHRA_PLAN = 'SAME_ICHRA_PLAN',
  TARGET_PLAN = 'TARGET_PLAN',
  RENEWAL_BASELINE = 'RENEWAL_BASELINE',
  PRIOR_YEAR_ON_MARKET_LOW_COST_SILVER = 'PRIOR_YEAR_ON_MARKET_LOW_COST_SILVER',
}
